import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AsesorJefeResponse, RegistrosSeguimientoResponse } from '../../models/seguimiento-jefe/asesor-jefe.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class SeguimientoJefeService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.SEGUIMIENTO_JEFE_ASESORES}`;

  constructor(private httpClient: HttpClient) { }

  /**
   * Obtiene los asesores a cargo del jefe logueado
   * @param idJefe ID del jefe comercial logueado
   * @returns Observable con la lista de asesores
   */
  private readonly registrosUrl = `${environment.HOST}${URL_MAP.API.SEGUIMIENTO_JEFE_REGISTROS}`;
  private readonly exportarUrl  = `${environment.HOST}${URL_MAP.API.SEGUIMIENTO_JEFE_EXPORTAR}`;

  getRegistrosSeguimiento(idJefe: string): Observable<RegistrosSeguimientoResponse> {
    const headers = new HttpHeaders({ 'X-Id-Jefe': idJefe });
    return this.httpClient.get<RegistrosSeguimientoResponse>(this.registrosUrl, { headers }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  exportarSeguimiento(idJefe: string, ids: number[]): Observable<Blob> {
    const headers = new HttpHeaders({ 'X-Id-Jefe': idJefe });
    return this.httpClient.post(this.exportarUrl, { ids }, { headers, responseType: 'blob' }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getAsesoresPorJefe(idJefe: string): Observable<AsesorJefeResponse> {
    const headers = new HttpHeaders({ 'X-Id-Jefe': idJefe });
    return this.httpClient.get<AsesorJefeResponse>(this.apiUrl, { headers }).pipe(
      catchError(error => {
        let errorMessage: string;
        if (error.status === 404) {
          errorMessage = 'No se encontraron asesores para este jefe.';
        } else if (error.status === 500) {
          errorMessage = 'Error en el servidor al obtener los asesores.';
        } else {
          errorMessage = error.error?.message || 'Error al consultar asesores.';
        }
        console.error('Error en getAsesoresPorJefe:', error);
        return throwError(() => errorMessage);
      })
    );
  }
}
